import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  large?: boolean;
}
const CART_URL = 'https://maestriasdigitales.shop/cart/add?id=43019622645821&quantity=1';
export function CTAButton({
  children,
  className = '',
  large = false
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (typeof window !== 'undefined' && typeof (window as any).fbq === 'function') {
      ;
      (window as any).fbq('track', 'AddToCart');
    }
    setTimeout(() => {
      window.location.href = CART_URL;
    }, 200);
  };
  return <a href={CART_URL} data-cta="add-to-cart" onClick={handleClick} className={`block w-full text-center bg-cta hover:bg-cta-hover text-white font-bold rounded-xl border border-transparent hover:border-primary shadow-sm transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary/50 ${large ? 'py-4 md:py-5 text-lg md:text-xl' : 'py-3 text-base'} ${className}`} data-id="element-54">
      {children}
    </a>;
}